import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { ArrowUpRight, Crosshair, Target, Clock3, Diamond } from "lucide-react";

const EMPTY = "—";

export const DashboardStats = () => {
  const stats = [
    { label: "Rang actuel", value: EMPTY, change: EMPTY, note: "aucune donnée", icon: Diamond, kind: "rank" },
    { label: "Taux de victoire", value: EMPTY, unit: "%", change: EMPTY, note: "aucune donnée", icon: Target },
    { label: "Ratio K/D", value: EMPTY, change: EMPTY, note: "aucune donnée", icon: Crosshair },
    { label: "Temps d’entraînement", value: EMPTY, unit: "h", change: EMPTY, note: "aucune donnée", icon: Clock3 }
  ];
  return <div className="dashboard-stats">
    {stats.map((s, i) => <div key={s.label} className="stat-item" data-testid={`dashboard-stat-${i}`}>
      <div className="stat-label">{s.label}<s.icon size={15} /></div>
      <div className="stat-value">{s.kind && <span className="rank-emblem"><Diamond size={23} /></span>}{s.value}<small>{s.unit}</small></div>
      <div className="stat-comparison"><span>{s.change}</span><small>{s.note}</small></div>
    </div>)}
  </div>;
};

export const ProgressChart = ({ game, period }) => {
  const count = period === "7" ? 7 : period === "30" ? 30 : 90;
  const data = Array.from({ length: count }, (_, i) => ({ day: period === "90" ? `${i * 3 + 1} j` : `${i + 1} sept.`, rank: null }));
  return <>
    <div className="chart-summary">
      <span className="chart-total" data-testid="rank-points">{EMPTY}<small> points de classement</small></span>
      <span className="chart-legend"><i />{game || "Aucun jeu"}</span>
    </div>
    <div className="rank-chart" data-testid="progress-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 15, right: 4, left: -26, bottom: 4 }}>
          <defs><linearGradient id="rank-fill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#578871" stopOpacity={.13} /><stop offset="95%" stopColor="#578871" stopOpacity={.01} /></linearGradient></defs>
          <CartesianGrid strokeDasharray="3 5" vertical={false} stroke="#e9ebe9" />
          <XAxis dataKey="day" axisLine={false} tickLine={false} minTickGap={65} tick={{ fill: "#90928f", fontSize: 10 }} dy={12} />
          <YAxis axisLine={false} tickLine={false} domain={[0, 200]} ticks={[0, 50, 100, 150, 200]} tick={{ fill: "#90928f", fontSize: 10 }} />
          <Tooltip contentStyle={{ background: "#fff", border: "1px solid #e7e8e6", borderRadius: 6, fontSize: 12 }} formatter={v => [`${v ?? "—"} points`, "Classement"]} />
          <Area type="monotone" dataKey="rank" stroke="#56816d" strokeWidth={2} fill="url(#rank-fill)" animationDuration={650} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
    <div className="chart-bottom"><span><span className="rank-dot" />{EMPTY}</span><span>{EMPTY} <span className="rank-dot current" /></span></div>
  </>;
};
